/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { FSBTable } from 'components/common/FSBTable';
import { defaultDeleteFilter, showSequenceNumber } from 'utils/constants';
import { OFFERS_QUERY, OFFERS_SUBSCRIPTION_QUERY } from 'utils/CommonGraphQL';
import { cloneDeep, isEmpty } from 'lodash';
import { vendorOffersColumns } from 'components/Drawers/components/VendorDetailsDrawer/constant';

const MyOffers = () => {
  const { selectedVendor } = useSelector((state) => state.vendorDetailsReducer);

  const [filters, setFilters] = useState({
    filter: [
      { key: 'trader', value: selectedVendor?.id, type: 'INT', op: 'EQ' },
      { ...defaultDeleteFilter },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
  });

  const { data, loading, error, subscribeToMore } = useQuery(OFFERS_QUERY, {
    variables: filters,
    fetchPolicy: 'network-only',
  });

  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };
  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo,
      pageSize,
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  const findIndexOfItem = (item) => {
    return vendorOffersColumns.findIndex((itm) => itm.accessorKey === item);
  };
  vendorOffersColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);

  useEffect(() => {
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
    const unsubscribe = subscribeToMore({
      document: OFFERS_SUBSCRIPTION_QUERY,
      variables: { ...filters, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData.offers.offers.findIndex(
          (val) => val.id === subscriptionData.data?.offers?.offer?.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (subscriptionData.data.offers.action === 'CREATED') {
          const newOffer = subscriptionData.data.offers.offer;
          const updatedOffers = [newOffer, ...newData.offers.offers];

          const newTotalCount = prev.offers.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.offers = {
            ...newData.offers,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            offers: updatedOffers,
          };
        }
        if (subscriptionData.data.offers.action === 'UPDATED') {
          newData.offers.offers[indexFound] =
            subscriptionData.data.offers.offer;
        }

        if (subscriptionData.data.offers.action === 'DELETED') {
          const { id } = subscriptionData.data.offers.offer; // ID of the offer to remove
          const prevOffers = prev.offers.offers;

          const updatedOffers = prevOffers.filter((val) => val.id !== id);

          const newTotalCount = prev.offers.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedOffersData = {
            ...newData.offers,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            offers: updatedOffers,
          };

          newData.offers = updatedOffersData;
        }

        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <FSBTable
      data={(data && data?.offers?.offers) || []}
      totalCount={(data && data?.offers?.totalCount) || 0}
      totalPages={(data && data?.offers?.totalPages) || 0}
      columns={vendorOffersColumns}
      currentPageNo={filters.pageNo}
      keyField="id"
      search={false}
      pagination
      remote
      loading={loading}
      striped={false}
      hover={false}
      bordered={false}
      wrapperClass="table-responsive word-break"
      pageSize={filters.pageSize}
      handlePageChange={handlePageChange}
      onSortChange={onSortChange}
      sorting={sortBy}
    />
  );
};
export default MyOffers;
